import { IconButton } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'

type Props = {
  page: number
}

export const PageDots = () => {
  return <Space>
    <Typo size={11} medium>{'\u2026'}</Typo>
  </Space>
}

export const PageButton = observer(({ page }: Props) => {
  const demo = useDemo()
  const { form } = demo
  const text = (page + 1).toFixed()
  const selected = page === form.page

  const onClick = useLatestCallback(() => {
    demo.form.page = page
  })

  return <IconButton key={page} outline={selected} action={onClick}>
    <Typo size={11} medium>{text}</Typo>
  </IconButton>
})
